import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeatureGrid from './components/FeatureGrid';
import GossipGrid from './components/GossipGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import BottomGrid from './components/BottomGrid';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '吃瓜官网',
  alternateName: '51吃瓜官网入口',
  url: 'https://chigua.cn/',
  description: '吃瓜官网汇聚51吃瓜官网入口与吃瓜官网免费资源，聚焦黑料吃瓜官网今日大瓜独家爆料，网红塌房现场实时更新，吃瓜群众必备的在线吃瓜平台。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://chigua.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '吃瓜官网',
  url: 'https://chigua.cn/',
  description: '吃瓜官网 — 51吃瓜在线第一入口，汇聚全网最新最全的黑料吃瓜与网红翻车现场。',
  email: 'contact@chigua.cn',
  telephone: '400-888-6666',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1-A座 18层',
    addressLocality: '北京市',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
  sameAs: [],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '吃瓜官网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜官网是一个汇聚全网最新爆料、网红翻车现场、明星大瓜、黑料实锤等内容的在线吃瓜平台，提供51吃瓜官网入口与吃瓜官网免费资源，是吃瓜群众必备的吃瓜网站。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜官网的内容是否真实可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜官网坚持有图有真相的原则，所有爆料内容均经过多方核实，确保信息的真实性和可靠性。我们不传播未经证实的谣言，致力于为吃瓜群众提供高质量的独家爆料内容。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在吃瓜官网上找到最新的今日大瓜？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜官网首页每日实时更新最新爆料内容，您可以通过首页的"最新大瓜"区域浏览当日热点，或通过分类导航进入"热门爆料""网红翻车""黑料专区"等板块查看特定类型的爆料内容。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜官网是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，吃瓜官网完全免费。所有爆料内容均免费向用户开放，无需注册或付费即可浏览全部内容。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategoryNav />
          <FeatureGrid />
          <GossipGrid />
          <CTASection />
          <TestimonialSection />
          <BottomGrid />
        </main>

        <Footer />
      </div>
    </>
  );
}